import { createApp, h } from 'vue';
import Sliders from '@components-molecules/Sliders.vue';

/* eslint-disable no-new */
export default function () {
  const container = document.createElement('div');
  document.body.appendChild(container);
  const component = {
    render: () => h(Sliders),
  };

  return createApp(component).mount(container);
}
